import { normaliseTag, TAG_MAX_LENGTH } from '@clm/shared-types';

/**
 * CLM-77 — what a raw tag will become. Shared by `TagInput`'s live preview and
 * its commit path, and exported on its own so the component file exports only
 * components (react-refresh). `normaliseTag` is the one normaliser — the same
 * function the API re-normalises with.
 */
export type TagPreview =
  | { readonly kind: 'empty' }
  | { readonly kind: 'ok'; readonly tag: string }
  | { readonly kind: 'bad'; readonly reason: string };

export function previewOf(raw: string): TagPreview {
  if (raw.trim() === '') return { kind: 'empty' };
  const tag = normaliseTag(raw);
  if (tag !== null) return { kind: 'ok', tag };
  const collapsed = raw.toLowerCase().trim().replace(/\s+/g, ' ');
  if (collapsed.length > TAG_MAX_LENGTH) {
    return { kind: 'bad', reason: `too long: at most ${String(TAG_MAX_LENGTH)} characters` };
  }
  return { kind: 'bad', reason: 'not allowed: only a–z, 0–9, space, hyphen' };
}
